import { render, staticRenderFns } from "./ModalMedia.vue?vue&type=template&id=61d00292&"
import script from "./ModalMedia.vue?vue&type=script&lang=js&"
export * from "./ModalMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports